import React from 'react'

import {
  DateTimeField,
  FieldSpec,
  LinkedPathField,
  PaginatedTable,
  RelatedLinkedField,
  UnitLocUnitField,
  ValueField,
} from 'src/components/Table'
import { ListTableProps } from './types'

const fieldOptions: { [key: string]: FieldSpec } = {
  sku: {
    id: 'sku',
    label: 'SKU',
    ordering: 'sku__sku',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  client: {
    id: 'sku.client',
    label: 'Client',
    ordering: 'sku__account__name',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  product: {
    id: 'product',
    label: 'Product',
    ordering: 'product__name',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  batch: {
    id: 'batch',
    label: 'Batch',
    ordering: 'client_uid',
    renderer: RelatedLinkedField(ValueField, 'name')
  },
  container: {
    id: 'container',
    label: 'Lost On',
    ordering: 'container__guid',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  numUnits: {
    id: 'numUnits',
    label: 'Number of Units',
    ordering: 'num_units',
    renderer: UnitLocUnitField,
  },
  dateReceived: {
    id: 'dateReceived',
    label: 'Date Units Received',
    ordering: 'date_received',
    renderer: DateTimeField,
  },
  path: {
    id: 'objPath',
    label: 'Last Seen',
    ordering: 'original_place__search_path',
    renderer: LinkedPathField,
  },
}

export const LostListTable = (props: ListTableProps) => {
  const { paginator, title, fields, exportConfig } = props

  return (
    <>
      <PaginatedTable
        title={title || 'Lost'}
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        exportConfig={exportConfig}
      />
    </>
  )
}
